import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  NrouteLandingHeader,
  NrouteHero,
  NrouteFeatures,
  NrouteHowItWorks,
  NrouteRequestAccess,
  NrouteClosingCTA,
  NrouteFooter,
  useLandingGate,
} from '../components/landing/nroute';

// Premium nroute marketing landing — rendered at "/" for logged-out visitors.
// Logged-in users and OAuth callbacks are redirected by useLandingGate.
export default function NrouteLanding() {
  const location = useLocation();
  const redirecting = useLandingGate();
  const requestRef = useRef(null);

  // Preserve attribution params (?partner=...&utm_source=...) when sending to login.
  const loginHref = `/login${location.search}`;

  const scrollToRequest = () =>
    requestRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  // While the gate resolves a redirect (authed user / OAuth), render nothing to avoid a flash.
  if (redirecting) return null;

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--brand-bg)' }}>
      <NrouteLandingHeader onRequestAccess={scrollToRequest} loginHref={loginHref} />
      <main>
        <NrouteHero onRequestAccess={scrollToRequest} loginHref={loginHref} />
        <NrouteFeatures />
        <NrouteHowItWorks />
        <NrouteRequestAccess sectionRef={requestRef} />
        <NrouteClosingCTA onRequestAccess={scrollToRequest} />
      </main>
      <NrouteFooter />
    </div>
  );
}
